module.exports = __webpack_public_path__ + "img/world-map.4748ae76.svg";